module.exports = __webpack_public_path__ + "static/media/health_wearable.b39e53ea.jpg";